var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsArray, IsBoolean, IsDateString, IsNumber, IsObject, IsOptional, IsString, IsUUID, } from 'class-validator';
import { ExerciseTemplateFolderFullSizeDto } from '../../exercise-templates/index.js';
import { NotificationFullSizeDto } from '../../notification/index.js';
import { OfficeProductAssignmentFullSizeDto } from '../../office-products/dtos/office-product-assignment.full-size.dto.js';
import { OfficeLiteDto } from '../../offices/dto/office.lite.dto.js';
import { TrainingSessionFullSizeDto } from '../../training-sessions/index.js';
import { UserFullSizeDto } from '../../user/index.js';
import { ExerciseProgramForCalendarFullSizeDto } from './exercise-program-calendar.dto.js';
import { ExerciseProgramItemFullSizeDto } from './exercise-program-item.full-size.dto.js';
export class ExerciseProgramFullSizeDto {
    id;
    createdAt;
    updatedAt;
    name;
    version;
    startDate = new Date();
    endDate;
    userId;
    user;
    exerciseProgramItems = [];
    trainingIsOnMonday;
    trainingIsOnTuesday;
    trainingIsOnWednesday;
    trainingIsOnThursday;
    trainingIsOnFriday;
    trainingIsOnSaturday;
    trainingIsOnSunday;
    diagnosisId;
    diagnosis;
    exerciseTemplateFolders = [];
    officeId;
    office;
    trainingSessions;
    index;
    notifications;
    userOfficeId;
    calendarItem;
    officeProductAssignmentId;
    officeProductAssignment;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], ExerciseProgramFullSizeDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Expose(),
    __metadata("design:type", Date)
], ExerciseProgramFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], ExerciseProgramFullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", Object)
], ExerciseProgramFullSizeDto.prototype, "name", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], ExerciseProgramFullSizeDto.prototype, "version", void 0);
__decorate([
    IsDateString(),
    Expose(),
    __metadata("design:type", Object)
], ExerciseProgramFullSizeDto.prototype, "startDate", void 0);
__decorate([
    IsDateString(),
    Expose(),
    __metadata("design:type", Object)
], ExerciseProgramFullSizeDto.prototype, "endDate", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], ExerciseProgramFullSizeDto.prototype, "userId", void 0);
__decorate([
    IsObject(),
    Type(() => UserFullSizeDto),
    Expose(),
    __metadata("design:type", Object)
], ExerciseProgramFullSizeDto.prototype, "user", void 0);
__decorate([
    IsArray(),
    Type(() => ExerciseProgramItemFullSizeDto),
    Expose(),
    __metadata("design:type", Array)
], ExerciseProgramFullSizeDto.prototype, "exerciseProgramItems", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], ExerciseProgramFullSizeDto.prototype, "trainingIsOnMonday", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], ExerciseProgramFullSizeDto.prototype, "trainingIsOnTuesday", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], ExerciseProgramFullSizeDto.prototype, "trainingIsOnWednesday", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], ExerciseProgramFullSizeDto.prototype, "trainingIsOnThursday", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], ExerciseProgramFullSizeDto.prototype, "trainingIsOnFriday", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], ExerciseProgramFullSizeDto.prototype, "trainingIsOnSaturday", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], ExerciseProgramFullSizeDto.prototype, "trainingIsOnSunday", void 0);
__decorate([
    Expose(),
    IsArray(),
    Type(() => ExerciseTemplateFolderFullSizeDto),
    __metadata("design:type", Array)
], ExerciseProgramFullSizeDto.prototype, "exerciseTemplateFolders", void 0);
__decorate([
    IsUUID(),
    Exclude(),
    __metadata("design:type", Object)
], ExerciseProgramFullSizeDto.prototype, "officeId", void 0);
__decorate([
    IsObject(),
    Type(() => OfficeLiteDto),
    Exclude(),
    __metadata("design:type", Function)
], ExerciseProgramFullSizeDto.prototype, "office", void 0);
__decorate([
    Expose(),
    IsArray(),
    Type(() => TrainingSessionFullSizeDto),
    __metadata("design:type", Array)
], ExerciseProgramFullSizeDto.prototype, "trainingSessions", void 0);
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Object)
], ExerciseProgramFullSizeDto.prototype, "index", void 0);
__decorate([
    IsArray(),
    Type(() => NotificationFullSizeDto),
    Exclude(),
    __metadata("design:type", Array)
], ExerciseProgramFullSizeDto.prototype, "notifications", void 0);
__decorate([
    IsUUID(),
    Exclude(),
    __metadata("design:type", Object)
], ExerciseProgramFullSizeDto.prototype, "userOfficeId", void 0);
__decorate([
    Expose(),
    IsObject(),
    Type(() => ExerciseProgramForCalendarFullSizeDto),
    __metadata("design:type", ExerciseProgramForCalendarFullSizeDto)
], ExerciseProgramFullSizeDto.prototype, "calendarItem", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], ExerciseProgramFullSizeDto.prototype, "officeProductAssignmentId", void 0);
__decorate([
    IsObject(),
    IsOptional(),
    Expose(),
    Type(() => OfficeProductAssignmentFullSizeDto),
    __metadata("design:type", Object)
], ExerciseProgramFullSizeDto.prototype, "officeProductAssignment", void 0);
//# sourceMappingURL=exercise-program.full-size.dto.js.map